import React from "react";
import styled from "styled-components";

function FlexStart(props) {
    const FlexStart = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: flex-start;
  `;
  return (
    <FlexStart>
        {props.children}
    </FlexStart>
  );
}

export default FlexStart;
